export default function NavBack(props) {
  const { onClick } = props;

  return (
    <div
      style={{
        position: "absolute",
        left: "0.57rem",
        top: "0.33rem",
        width: "1.35rem",
        height: "1.03rem",
        backgroundImage: `url(${require("../imgs/nav_back.png")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      }}
      onClick={() => {
        onClick && onClick();
      }}
    ></div>
  );
}
